import React, { useCallback } from "react";
import Template from "./Confirm.jsx";
import "./styles.styl";

const ConfirmController = (props) => {
  const onConfirmClick = useCallback(() => {
    const { onConfirm } = props;
    onConfirm && onConfirm();
  }, [props]);

  const onAbortClick = useCallback(() => {
    const { onAbort } = props;
    onAbort && onAbort();
  }, [props]);

  const handlers = {
    onConfirmClick,
    onAbortClick,
  };

  return <Template {...props} {...handlers} />;
};

export default ConfirmController;
